/* eslint-disable quotes */
/* eslint-disable prefer-template */
import { apiPath } from "@/api/api-path"
import axios from "axios"
import store from "@/store/index"
import api from "./service"

let username = store.getters["authStore/getUsername"]

let tokenForExternal
let usernameForExternal

function setTokenFromVuex() {
  tokenForExternal = store.state.appPermission.token
  usernameForExternal = store.state.appPermission.username
}

export async function getNotiConfig(isInternal = false) {
  if (isInternal) {
    return api
      .get(apiPath.getNotiConfig, {})
      .then((response) => {
        if (response.status === 200) return response.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  } else {
    setTokenFromVuex()
    return axios
      .get(apiPath.getNotiConfig, {
        headers: {
          Authorization: "Bearer " + tokenForExternal, // the token is a variable which holds the token
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
}

// Get Noti
export async function getNoti(isInternal = false) {
  if (isInternal) {
    return api
      .get(apiPath.getNoti, {})
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  } else {
    setTokenFromVuex()
    return axios
      .get(apiPath.getNoti, {
        headers: {
          Authorization: "Bearer " + tokenForExternal, // the token is a variable which holds the token
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
}

export async function updateNotiStatusToSeen(
  notificationIds,
  isInternal = false
) {
  if (isInternal) {
    const body = {
      username: username,
      notificationId: notificationIds,
    }
    return api
      .patch(apiPath.updateNotiStatusToSeen, body, {})
      .then((response) => {
        if (response.status === 204) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  } else {
    setTokenFromVuex()
    const body = {
      username: usernameForExternal,
      notificationId: notificationIds,
    }
    return axios
      .patch(apiPath.updateNotiStatusToSeen, body, {
        headers: {
          Authorization: "Bearer " + (isInternal ? token : tokenForExternal), // the token is a variable which holds the token
        },
      })
      .then((response) => {
        if (response.status === 204) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
}

export async function updateNotiStatusToRead(
  notificationIds,
  isInternal = false
) {
  if (isInternal) {
    const body = {
      username: username,
      notificationId: notificationIds,
    }
    return api
      .patch(apiPath.updateNotiStatusToRead, body, {})
      .then((response) => {
        if (response.status === 204) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  } else {
    setTokenFromVuex()
    const body = {
      username: usernameForExternal,
      notificationId: notificationIds,
    }
    return axios
      .patch(apiPath.updateNotiStatusToRead, body, {
        headers: {
          Authorization: "Bearer " + (isInternal ? token : tokenForExternal), // the token is a variable which holds the token
        },
      })
      .then((response) => {
        if (response.status === 204) return response.data.data
      })
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
}
